import { useState } from "react";

export interface FaqItem {
  q: string;
  a: string;
}

export default function FaqList({ items }: { items: FaqItem[] }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <div>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="divide-y divide-background-200 border border-background-200 rounded-lg bg-background-50 overflow-hidden">
        {items.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={i}>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left hover:bg-background-100/60 transition-colors"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-900">
                  {item.q}
                </span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 shrink-0">
                  <i
                    className={`text-sm transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                  />
                </span>
              </button>
              {isOpen && (
                <div className="px-4 md:px-5 pb-4">
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}